import React from "react";
import { useNavigate } from "react-router-dom";
import SETTINGS from "../../../globals";
import AppSections from "../../../utils/AppSections";
import AppSubSections from "../../../utils/AppSubSections";
import ButtonInfo from "../button/ButtonInfo";
import AppIcons from "../../../utils/AppIcons";
import CHElement from "../../../model/CHElement";
import EntityStats from "../../../model/EntityStats";
import ChemiNovaEntityType from "../../../model/enums/ChemiNovaEntityType";

interface IChelementMapElementProps {
  data: CHElement;
  canEdit: boolean;
}

function ChelementMapElement({ data, canEdit }: IChelementMapElementProps) {
  // reference to the navigator
  const navigate = useNavigate();

  return (
    <div
      className="cursor-pointer p-4 border rounded-lg shadow-md"
      onClick={() => {
        navigate(
          SETTINGS.get_path({
            section: AppSections.CHELEMENTS,
            id: data.id,
            subsection: AppSubSections.VIEW,
          })
        );
      }}
    >
      <div>
        <h3 className="text-left font-semibold">{data.name}</h3>
        <br></br>
        <div className="h-32 overflow-y-auto">
          <p className="text-gray-600">{data.description}</p>
        </div>
        <br></br>
        <ButtonInfo>
          {AppIcons.E3D}
          <span>
            {EntityStats.getStats(data.counts, ChemiNovaEntityType.E3DMODEL)}
          </span>
          e3Ds
        </ButtonInfo>

        <ButtonInfo>
          {AppIcons.ANNOTATIONS}
          <span>
            {EntityStats.getStats(data.counts, ChemiNovaEntityType.ANNOTATION)}
          </span>
          annotations
        </ButtonInfo>

        <ButtonInfo>
          {AppIcons.DOCUMENTS}
          <span>
            {EntityStats.getStats(data.counts, ChemiNovaEntityType.ANNEX_DATA)}
          </span>
          documents
        </ButtonInfo>

        <ButtonInfo>
          {AppIcons.USER}
          Created by: <span>{data.username}</span>
        </ButtonInfo>
      </div>
    </div>
  );
}

export default ChelementMapElement;
